import React from 'react';
import { useShippingSettings } from '../context/ShippingSettingsContext';

function FreeShippingBanner() {
  const { freeShippingThreshold } = useShippingSettings();
  return (
    <div className="free-shipping-banner">
      <div className="container">
        <div className="d-flex align-items-center justify-content-center gap-2 py-2">
          <i className="bi bi-truck fs-6" style={{ color: '#F78F11' }} />
          <span className="free-shipping-text">
            <strong>Free Shipping</strong> on orders over £{freeShippingThreshold}
          </span>
        </div>
      </div>
    </div>
  );
}

export default FreeShippingBanner;
